









import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class PasswordCondition extends Vue {
    @Prop(Boolean) condition!: boolean;
    @Prop(String) text!: string;
}
